<template>
    <div class="config-group small-12 column d-flex flex-column align-items-center conf-3Dmodel">
        <div class="config-item w-100 position-relative">
            <div class="d-flex flex-wrap align-items-center input-calc h-spacing-4">
                <div class="input-calc__container position-relative d-flex align-items-center flex-child-auto"
                    v-for="( value, key ) in conf3dModel" v-bind:key="key">
                    <div class="flex-child-auto">
                        <div class="config-item__info d-inline-flex">
                            <label :for="key" class="input-calc__label">{{ getPrintQLabel( key ) }}</label>
                            <Tooltip :infoText="getToolTip(key)"/>
                        </div>
                        <input type="number" class="text-center w-100" required
                               :id="key"
                               :value="value"
                               @change="dimensionChanged( key, $event )"
                               :class="{ 'error': configuratorService.byConfigoptionType('Printq').dynamicValues.printQErrorFields?.includes(key) }"/>
                    </div>
                </div>
            </div>
<!--            <div v-for="( message, key ) in printQErrorFields" v-bind:key="key" class="text-small mt-prj2 text-error d-flex line-height-12">
                <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 svg-icon flex-child-fix position-relative t-1px" viewBox="0 0 36 36"><circle cx="18" cy="18" r="18" fill="#e94d47"/><path d="M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z" fill="#fff"/></svg>
                {{ message }}
            </div>-->
        </div>
    </div>
</template>

<script>
import Tooltip from "components/Tooltip";

    export default {
      name: "PrintQFields.vue",
      components: {Tooltip},
      inject: ['printqService', 'configuratorService'],
      computed: {
        conf3dModel(){
          return this.configuratorService.byConfigoptionType("Printq").dynamicValues.conf3DModel;
        }
      },
      methods: {
        dimensionChanged(option, event) {
          let newValue = event.target.value
          this.printqService.update3DModel( option, newValue )
        },
            getPrintQLabel( key ) {
                return this.configuratorService.byConfigoptionType("Printq").customValues.labels[key];
            },
            getToolTip (key) {
              return this.configuratorService.byConfigoptionType("Printq").customValues.tooltips[key];
            }
        },
        mounted: function () {
        }
    }

</script>
